module.exports = __webpack_public_path__ + "static/media/tag_augmented_performance.1843672d.svg";